import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { connect } from 'react-redux';

import FilterBarContainer from './FilterBarContainer';
import ResultListContainer from './ResultListContainer';
import { Messages } from '../components/Messages';
import { ContentPanel } from '../components/ContentPanel';
import { updateSubscriberLink } from '../utils/updateSubscriberLink';
import { updateQuery, filterRequestAction } from '../redux/actions';

import * as Selectors from '../redux/selectors';

const ContentContainer = (props) => {
  const { dispatch, texts, messages } = props;

  const handleResetFilters = useCallback(
    (e, gtm) => {
      dispatch(updateQuery({ priceTo: '', tripTypes: '', destinationCode: '' }, gtm));
      dispatch(filterRequestAction());
      updateSubscriberLink({ priceTo: '', tripTypes: '', destinationCode: '' });
    },
    [dispatch],
  );

  return (
    <ContentPanel>
      <FilterBarContainer texts={texts} onResetFilters={handleResetFilters} />
      <Messages messages={messages} onResetFilters={handleResetFilters} />
      <ResultListContainer texts={texts} />
    </ContentPanel>
  );
};

ContentContainer.propTypes = {
  dispatch: PropTypes.func,
  texts: PropTypes.object,
  messages: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    messages: Selectors.getMessages(state),
  };
}

export const ConnectedContentContainer = connect(mapStateToProps)(ContentContainer);

export default ConnectedContentContainer;
